/* Retail Partners (stockist finder). Runs on every [data-rp] section.
   Map: MapLibre GL (loaded from unpkg when the section is near the viewport) + the style URL from the section
   (OpenFreeMap by default: free, no API key). Pins are a clustered GeoJSON source, so nearby stores collapse
   into a numbered circle until you zoom in. Everything else (tabs, search, Near me) is plain DOM work on the
   list Liquid already rendered, so the page is complete without this file. */
(function () {
  'use strict';

  var MAPLIBRE_JS = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.js';
  var MAPLIBRE_CSS = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.css';

  var US_STATES = { al: 'alabama', ak: 'alaska', az: 'arizona', ar: 'arkansas', ca: 'california', co: 'colorado', ct: 'connecticut', de: 'delaware', fl: 'florida', ga: 'georgia', hi: 'hawaii', id: 'idaho', il: 'illinois', in: 'indiana', ia: 'iowa', ks: 'kansas', ky: 'kentucky', la: 'louisiana', me: 'maine', md: 'maryland', ma: 'massachusetts', mi: 'michigan', mn: 'minnesota', ms: 'mississippi', mo: 'missouri', mt: 'montana', ne: 'nebraska', nv: 'nevada', nh: 'new hampshire', nj: 'new jersey', nm: 'new mexico', ny: 'new york', nc: 'north carolina', nd: 'north dakota', oh: 'ohio', ok: 'oklahoma', or: 'oregon', pa: 'pennsylvania', ri: 'rhode island', sc: 'south carolina', sd: 'south dakota', tn: 'tennessee', tx: 'texas', ut: 'utah', vt: 'vermont', va: 'virginia', wa: 'washington', wv: 'west virginia', wi: 'wisconsin', wy: 'wyoming', dc: 'washington dc' };

  var libPromise = null;
  function loadMapLibre() {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (libPromise) return libPromise;
    libPromise = new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = MAPLIBRE_CSS;
      document.head.appendChild(link);
      var script = document.createElement('script');
      script.src = MAPLIBRE_JS; script.async = true;
      script.onload = function () { window.maplibregl ? resolve(window.maplibregl) : reject(new Error('maplibre missing')); };
      script.onerror = function () { reject(new Error('maplibre failed to load')); };
      document.head.appendChild(script);
    });
    return libPromise;
  }

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad, dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function pinSvg(color, ink) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40"><path d="M15 39C15 39 2 23.5 2 14.5A13 13 0 0 1 28 14.5C28 23.5 15 39 15 39Z" fill="' + color + '" stroke="' + ink + '" stroke-width="1.5"/><circle cx="15" cy="14.5" r="4.5" fill="' + ink + '"/></svg>';
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function init(root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-rp-data]').textContent); } catch (e) { data = []; }
    var units = root.getAttribute('data-units') === 'km' ? 'km' : 'mi';
    var styleUrl = root.getAttribute('data-style');
    var center = (root.getAttribute('data-center') || '39.5,-98.5').split(',').map(parseFloat);
    var zoom = parseFloat(root.getAttribute('data-zoom') || '3');
    var accent = getComputedStyle(root).getPropertyValue('--rp-accent').trim() || '#467610';

    var list = root.querySelector('[data-rp-list]');
    var countEl = root.querySelector('[data-rp-count]');
    var emptyEl = root.querySelector('[data-rp-empty]');
    var nearbyEl = root.querySelector('[data-rp-nearby]');
    var tabs = [].slice.call(root.querySelectorAll('[data-rp-tabs] .rp__tab'));
    var searchEl = root.querySelector('[data-rp-search]');
    var clearEl = root.querySelector('[data-rp-clear]');
    var nearBtn = root.querySelector('[data-rp-near]');
    var nearLabel = root.querySelector('[data-rp-near-label]');
    var nearDefault = nearLabel ? nearLabel.textContent : 'Near me';
    var mapEl = root.querySelector('[data-rp-map]');

    var cards = {};
    [].slice.call(list.querySelectorAll('.rp__card')).forEach(function (li) { cards[li.getAttribute('data-id')] = li; });
    var stores = data.map(function (d) {
      d.card = cards[d.id] || null;
      d.hay = ((d.name || '') + ' ' + (d.city || '') + ' ' + (d.state || '') + ' ' + (d.country || '') + ' ' + (d.zip || '') + ' ' + (d.address || '')).toLowerCase();
      d.hasPin = typeof d.lat === 'number' && typeof d.lng === 'number' && !isNaN(d.lat) && !isNaN(d.lng);
      d.distance = null;
      return d;
    });

    /* alphabetical inside each group (blocks can be added in any order) */
    [].slice.call(list.querySelectorAll('.rp__group .rp__cards')).forEach(function (ul) {
      var items = [].slice.call(ul.children);
      items.sort(function (a, b) { return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '', undefined, { sensitivity: 'base' }); });
      items.forEach(function (li) { ul.appendChild(li); });
    });

    var state = { region: 'all', query: '', near: null };

    /* ---------- filtering ---------- */
    function tokens(q) {
      return q.toLowerCase().replace(/[,.]/g, ' ').split(/\s+/).filter(Boolean).map(function (t) { return US_STATES[t] || t; });
    }
    function matches(store) {
      if (state.region !== 'all' && store.region !== state.region) return false;
      if (!state.query) return true;
      var words = tokens(state.query);
      return words.every(function (w) {
        if (store.hay.indexOf(w) > -1) return true;
        /* word-start match on any field word, e.g. "brook" > Brooklyn, "spok" > Spokane */
        return store.hay.split(/[^a-z0-9]+/).some(function (h) { return h.indexOf(w) === 0; });
      });
    }
    function visibleStores() { return stores.filter(matches); }

    function applyFilter(opts) {
      var visible = visibleStores();
      var ids = {};
      visible.forEach(function (s) { ids[s.id] = true; });

      if (state.near) {
        /* nearest-first flat list */
        list.querySelectorAll('.rp__group').forEach(function (g) { g.hidden = true; });
        nearbyEl.hidden = false;
        var sorted = visible.slice().sort(function (a, b) { return (a.distance == null ? 1e9 : a.distance) - (b.distance == null ? 1e9 : b.distance); });
        nearbyEl.innerHTML = '';
        sorted.forEach(function (s) {
          if (!s.card) return;
          var clone = s.card.cloneNode(true);
          clone.hidden = false;
          clone.removeAttribute('id');
          var d = clone.querySelector('[data-rp-dist]');
          if (d && s.distance != null) { d.textContent = fmtDist(s.distance); d.hidden = false; }
          nearbyEl.appendChild(clone);
        });
      } else {
        nearbyEl.hidden = true;
        nearbyEl.innerHTML = '';
        stores.forEach(function (s) { if (s.card) s.card.hidden = !ids[s.id]; });
        list.querySelectorAll('.rp__group').forEach(function (g) {
          var any = [].slice.call(g.querySelectorAll('.rp__card')).some(function (c) { return !c.hidden; });
          g.hidden = !any;
        });
      }

      var n = visible.length;
      countEl.textContent = n + ' location' + (n === 1 ? '' : 's') + (state.query ? ' found' : '') + (state.near ? ', nearest first' : '');
      emptyEl.hidden = n > 0;
      if (clearEl) clearEl.hidden = !state.query;

      if (map && mapReady) {
        setMapData(visible);
        if (!(opts && opts.keepView)) fitTo(visible.filter(function (s) { return s.hasPin; }));
      }
    }

    function fmtDist(km) {
      var v = units === 'km' ? km : km * 0.621371;
      return (v < 10 ? v.toFixed(1) : Math.round(v)) + ' ' + units;
    }

    /* tabs */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        state.region = tab.getAttribute('data-region');
        applyFilter();
      });
    });

    /* search */
    var debounce;
    if (searchEl) {
      searchEl.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { state.query = searchEl.value.trim(); applyFilter(); }, 160);
      });
      searchEl.addEventListener('keydown', function (e) { if (e.key === 'Escape') { searchEl.value = ''; state.query = ''; applyFilter(); } });
    }
    if (clearEl) clearEl.addEventListener('click', function () { searchEl.value = ''; state.query = ''; applyFilter(); searchEl.focus(); });

    /* near me */
    if (nearBtn) {
      nearBtn.addEventListener('click', function () {
        if (state.near) { clearNear(); return; }
        if (!navigator.geolocation) { flashNear('No location'); return; }
        nearBtn.classList.add('is-busy');
        nearLabel.textContent = 'Locating';
        navigator.geolocation.getCurrentPosition(function (pos) {
          nearBtn.classList.remove('is-busy');
          state.near = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          stores.forEach(function (s) { s.distance = s.hasPin ? haversine(state.near.lat, state.near.lng, s.lat, s.lng) : null; });
          stores.forEach(function (s) {
            if (!s.card) return;
            var d = s.card.querySelector('[data-rp-dist]');
            if (d) { if (s.distance != null) { d.textContent = fmtDist(s.distance); d.hidden = false; } else { d.hidden = true; } }
          });
          nearBtn.classList.add('is-active');
          nearLabel.textContent = 'Clear';
          /* "Near me" ignores the region tab: the nearest stockist is the point */
          tabs.forEach(function (t) { var on = t.getAttribute('data-region') === 'all'; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          state.region = 'all';
          applyFilter({ keepView: true });
          if (map && mapReady) { setUserPin(state.near); fitNear(); }
        }, function () {
          nearBtn.classList.remove('is-busy');
          flashNear('Location off');
        }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
      });
    }
    function flashNear(text) {
      nearLabel.textContent = text;
      setTimeout(function () { nearLabel.textContent = nearDefault; }, 1800);
    }
    function clearNear() {
      state.near = null;
      stores.forEach(function (s) { s.distance = null; if (s.card) { var d = s.card.querySelector('[data-rp-dist]'); if (d) d.hidden = true; } });
      nearBtn.classList.remove('is-active');
      nearLabel.textContent = nearDefault;
      if (map && mapReady) setUserPin(null);
      applyFilter();
    }

    /* card > map */
    function onCardClick(e) {
      var showBtn = e.target.closest('[data-rp-show]');
      var card = e.target.closest('.rp__card');
      if (!card) return;
      if (e.target.closest('a')) return;
      if (!showBtn && !card.hasAttribute('data-lat')) return;
      var id = card.getAttribute('data-id');
      var store = stores.filter(function (s) { return s.id === id; })[0];
      if (!store || !store.hasPin) return;
      highlight(id);
      if (map && mapReady) {
        map.flyTo({ center: [store.lng, store.lat], zoom: Math.max(map.getZoom(), 11), duration: 700 });
        openPopup(store);
        if (window.innerWidth <= 1024) mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    list.addEventListener('click', onCardClick);

    function highlight(id) {
      [].slice.call(list.querySelectorAll('.rp__card')).forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-id') === id); });
    }

    /* ---------- map ---------- */
    var map = null, mapReady = false, popup = null, userMarker = null;

    function toGeoJSON(arr) {
      return { type: 'FeatureCollection', features: arr.filter(function (s) { return s.hasPin; }).map(function (s) {
        return { type: 'Feature', geometry: { type: 'Point', coordinates: [s.lng, s.lat] }, properties: { id: s.id, icon: s.iconName || 'rp-pin' } };
      }) };
    }
    function setMapData(arr) {
      var src = map.getSource('rp-stores');
      if (src) src.setData(toGeoJSON(arr));
    }
    function fitTo(arr) {
      if (!arr.length) return;
      if (arr.length === 1) { map.easeTo({ center: [arr[0].lng, arr[0].lat], zoom: 10, duration: 600 }); return; }
      var b = new maplibregl.LngLatBounds();
      arr.forEach(function (s) { b.extend([s.lng, s.lat]); });
      map.fitBounds(b, { padding: { top: 48, right: 48, bottom: 48, left: 48 }, maxZoom: 11, duration: 700 });
    }
    function fitNear() {
      var nearest = stores.filter(function (s) { return s.hasPin && s.distance != null; }).sort(function (a, b) { return a.distance - b.distance; }).slice(0, 3);
      var b = new maplibregl.LngLatBounds([state.near.lng, state.near.lat], [state.near.lng, state.near.lat]);
      nearest.forEach(function (s) { b.extend([s.lng, s.lat]); });
      map.fitBounds(b, { padding: 64, maxZoom: 10, duration: 800 });
    }
    function setUserPin(pos) {
      if (userMarker) { userMarker.remove(); userMarker = null; }
      if (!pos) return;
      var el = document.createElement('div');
      el.style.cssText = 'width:16px;height:16px;border-radius:50%;background:#151515;border:3px solid #fff;box-shadow:0 0 0 2px #151515';
      userMarker = new maplibregl.Marker({ element: el }).setLngLat([pos.lng, pos.lat]).addTo(map);
    }
    function openPopup(store) {
      if (popup) popup.remove();
      var addr = [store.address, [store.city, store.region === 'us' ? store.state : store.country].filter(Boolean).join(', ') + (store.zip ? ' ' + store.zip : '')].filter(Boolean);
      var html = '<span class="rp__pop-name">' + escapeHtml(store.name) + '</span>' +
        '<p class="rp__pop-addr">' + addr.map(escapeHtml).join('<br>') + (store.hours ? '<br><span style="color:#6f6f66">' + escapeHtml(store.hours) + '</span>' : '') + '</p>' +
        '<p class="rp__pop-links"><a href="https://www.google.com/maps/dir/?api=1&destination=' + store.lat + ',' + store.lng + '" target="_blank" rel="noopener">Directions</a>' +
        (store.website ? '<a href="' + escapeHtml(store.website) + '" target="_blank" rel="noopener">Website</a>' : '') + '</p>';
      popup = new maplibregl.Popup({ offset: [0, -34], maxWidth: '280px' }).setLngLat([store.lng, store.lat]).setHTML(html).addTo(map);
    }

    function buildMap(maplibregl) {
      map = new maplibregl.Map({
        container: mapEl,
        style: styleUrl,
        center: [center[1], center[0]],
        zoom: zoom,
        cooperativeGestures: true,
        attributionControl: { compact: true },
        dragRotate: false,
        pitchWithRotate: false
      });
      map.touchZoomRotate.disableRotation();
      map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');

      map.on('load', function () {
        /* pins: default + one per custom icon (WESN's own stores) */
        var jobs = [];
        var pinImg = loadImage('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(pinSvg(accent, '#151515')));
        jobs.push(pinImg.then(function (img) { map.addImage('rp-pin', img, { pixelRatio: 1 }); }));
        var seen = {};
        stores.forEach(function (s) {
          if (!s.icon) return;
          var name = 'rp-icon-' + s.icon.replace(/[^a-z0-9]/gi, '').slice(-24);
          s.iconName = name;
          if (seen[name]) return;
          seen[name] = true;
          jobs.push(loadImage(s.icon).then(function (img) { map.addImage(name, img, { pixelRatio: 2 }); }).catch(function () {
            stores.forEach(function (t) { if (t.iconName === name) t.iconName = 'rp-pin'; });
          }));
        });

        Promise.all(jobs.map(function (p) { return p.catch(function () {}); })).then(function () {
          map.addSource('rp-stores', { type: 'geojson', data: toGeoJSON(visibleStores()), cluster: true, clusterRadius: 44, clusterMaxZoom: 12 });
          map.addLayer({ id: 'rp-clusters', type: 'circle', source: 'rp-stores', filter: ['has', 'point_count'],
            paint: { 'circle-color': accent, 'circle-radius': ['step', ['get', 'point_count'], 18, 5, 22, 10, 26], 'circle-stroke-width': 2, 'circle-stroke-color': '#ffffff' } });
          map.addLayer({ id: 'rp-cluster-count', type: 'symbol', source: 'rp-stores', filter: ['has', 'point_count'],
            layout: { 'text-field': ['get', 'point_count_abbreviated'], 'text-size': 12, 'text-font': ['Noto Sans Bold'] }, paint: { 'text-color': '#ffffff' } });
          map.addLayer({ id: 'rp-points', type: 'symbol', source: 'rp-stores', filter: ['!', ['has', 'point_count']],
            layout: { 'icon-image': ['get', 'icon'], 'icon-size': 1, 'icon-anchor': 'bottom', 'icon-allow-overlap': true } });

          map.on('click', 'rp-clusters', function (e) {
            var f = map.queryRenderedFeatures(e.point, { layers: ['rp-clusters'] })[0];
            var id = f.properties.cluster_id;
            map.getSource('rp-stores').getClusterExpansionZoom(id, function (err, z) {
              if (err) return;
              map.easeTo({ center: f.geometry.coordinates, zoom: z + 0.5 });
            });
          });
          map.on('click', 'rp-points', function (e) {
            var id = e.features[0].properties.id;
            var store = stores.filter(function (s) { return s.id === id; })[0];
            if (!store) return;
            openPopup(store);
            highlight(id);
            var target = state.near ? nearbyEl.querySelector('[data-id="' + id + '"]') : store.card;
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          });
          ['rp-clusters', 'rp-points'].forEach(function (l) {
            map.on('mouseenter', l, function () { map.getCanvas().style.cursor = 'pointer'; });
            map.on('mouseleave', l, function () { map.getCanvas().style.cursor = ''; });
          });

          mapReady = true;
          mapEl.classList.add('is-ready');
          fitTo(visibleStores().filter(function (s) { return s.hasPin; }));
        });
      });

      map.on('error', function (e) {
        /* a style that will not load leaves the list working; say so instead of a blank box */
        if (e && e.error && /style|tiles/i.test(String(e.error.message || ''))) mapEl.classList.remove('is-ready');
      });
    }

    /* load the library only when the map is near the viewport */
    function start() { loadMapLibre().then(buildMap).catch(function () { /* list still works */ }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '600px 0px' });
      io.observe(mapEl);
    } else { start(); }

    applyFilter({ keepView: true });
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-rp]')).forEach(function (r) { if (!r.__rp) { r.__rp = true; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
